export class Flashcard {
  id: number | null;
  question: string;
  answer: string;
  dueDate: Date | null;
  learnset_id: number | null;
  page: number | null;

  constructor(id: number | null, question: string, answer: string, dueDate: string, learnset_id: number | null, page: number | null) {
    this.id = id;
    this.question = question.replace(/&nbsp;/g, ' ');
    this.answer = answer.replace(/&nbsp;/g, ' ');
    this.dueDate = dueDate ? new Date(dueDate) : null;
    this.learnset_id = learnset_id;
    this.page = page;
  }

  public static constructFlashcard(flashcard: any): Flashcard {
    return new Flashcard(flashcard.id, flashcard.question, flashcard.answer, flashcard.dueDate, flashcard.learnset_id, flashcard.page);
  }

  public isDue(): boolean {
    if (!this.dueDate) {
      return false;
    }
    const now = new Date();
    const dueDate = new Date(this.dueDate);
    return dueDate <= now;
  }
}